module.exports = __webpack_public_path__ + "img/BA.bd8d85a2.svg";